import store from "store2"; //storing browser data
import { dashToCamelCase } from "../../shared/helpers";
//sets session data
//local storage does not expire when page(session) is closed, while session storage will expire when page is closed

export const initStoreFluency = () => {
  if (store.session.has("initialized") && store.local("initialized")) {
    return store.session;
  }

  if (store.session.get("config").keyboardPractice === true) {
    store.session.set("keyboardInstruction", "practice");
  } else {
    store.session.set("keyboardInstruction", "noPractice");
  }

  store.session.set("displayImage", "tiger");
  if (store.session.get("config").labId === "numberLab") {
    store.session.set(
      "displayImage",
      dashToCamelCase(store.session.get("config").taskName + "-display"),
    );
  }

  // clear any timers if they exist in the browser
  if (store.session("timerId")) {
    clearTimeout(store.session.get("timerId"));
  }
  store.session.set("timerId", null);

  // for storing next stimulus
  store.session.set("nextStimulus", null);

  store.session.set("timerStatus", true);

  store.session.set("dataCorrect", null); // intialise data correct variable, gets updated in stimulusNumber.js
  store.session.set("correctCount", 0); //correct counter per block/corpus
  store.session.set("totalCorrect", 0); //overall correct
  store.session.set("trialNumTotal", 0); // counter for trials in experiment

  store.session.set("timeOut", false); // initialise the time out variable, gets updated in stimulusNumber.js
  if (store.session.get("config").taskName === "fluency-arf") {
    store.session.set("timerDuration", [180000]); //set the duration of timer (ms)
    store.session.set("timerForceQuit", 30000);
  } else if (store.session.get("config").taskName === "fluency-calf") {
    store.session.set("timerDuration", [60000, 60000, 60000]); //set the duration of timer (ms)
    //increase the time only for prolific number lab study
    if (
      store.session.get("config").recruitment === "prolific" &&
      store.session.get("config").labId === "numberLab"
    ) {
      store.session.set("timerDuration", [90000, 90000, 90000]); //set the duration of timer (ms)
    }
    store.session.set("timerForceQuit", 20000);
  }
  store.session.set("arrayIdx", 0);

  store.session.set("timeForceOut", false);

  // working copy of the three corpuses (items are removed as they are used)
  store.session.set("currentCorpus", ""); //initialise current corpus as empty string, gets updated in stimulusNumber.js

  store.session.set("practiceKeyPress", null);
  store.session.set("practiceResponse", null);
  store.session.set("response", null);
  store.session.set("practiceIncorrectCount", 0);
  store.session.set("practiceCorrect", 0);
  store.session.set("practiceFeedback", null);
  store.session.set("keyboardPracticeCounter", 0);
  store.session.set("allowKeyUp", false);

  // progress bar tracking
  store.session.set("startTimePB", null);
  //store.session.set("nextUpdatePB", 45000);
  //store.session.set("incrementPB", 45000);
  store.session.set(
    "totalTimePB",
    store.session.get("timerDuration").reduce((a, b) => a + b),
  );

  // index for keeping track of trials for timer
  store.session.set("indexTracking", -1); //gets updated in stimulusNumber.js

  // this should be the last set before return
  store.session.set("initialized", true);

  return store.session;
};
